import * as yup from 'yup';

const validationSchema = yup.object({
  caqh: yup.string().required('CAQH is required'),
  password: yup.string().required('Password is required'),
});

export { validationSchema };
